<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Novo atendimento de subgrupo</b>
						</h3>
					</div>
					<div class="box-body">
						<cabecalho-contrato :contrato-id="$route.params.contratoId"></cabecalho-contrato>
						<div class="row">
							<div class="col-md-9">
								<div class="form-group">
									<label>Subgrupo</label>
									<select-subgrupo :contrato-id="$route.params.contratoId" @setSubgrupoSelecionado="(subgrupoSelecionado)=>{setSubgrupoSelecionado(subgrupoSelecionado)}"></select-subgrupo>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Sexo</label>
									<select class="form-control" v-model="dados.sexo">
										<option value="0">Ambos</option>
										<option value="1">Masculino</option>
										<option value="2">Feminino</option>
									</select>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label>Idade mínima</label>
									<input type="number" class="form-control" v-model="dados.idade_minima">
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label>Idade máxima</label>
									<input type="number" class="form-control" v-model="dados.idade_maxima">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>Tipo Consumo</label>
									<select @change="trocaTipoConsumo" class="form-control" v-model="dados.tipo_consumo">
										<option value="0">Por Procedimento</option>
										<option value="1">Por Paciente</option>
									</select>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Atendimentos</label>
									<input :disabled="dados.tipo_consumo != 0" type="number" class="form-control" v-model="dados.quantidade_atendimento">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Local</label>
									<input :disabled="dados.tipo_consumo != 0" type="number" class="form-control" v-model="dados.quantidade_local">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Max. Pacientes</label>
									<input :disabled="dados.tipo_consumo != 1" type="number" class="form-control" v-model="dados.quantidade_paciente">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Dia(s)</label>
									<label for="">Dia da semana: </label>
									<v-select id="select-dias" placeholder="Clique para selecionar o(s) dia(s)..." multiple v-model="dias" :options="selectDias"></v-select>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Hora inicial</label>
									<input type="time" class="form-control" v-model="dados.hora_inicial">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Hora final</label>
									<input type="time" class="form-control" v-model="dados.hora_final">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<button @click="$router.go(-1)" class="btn btn-default pull-left"><span class="fa fa-reply"></span>	Voltar</button>
								<button @click="salvar()" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Salvar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http
	import selectSubgrupo from "../contratos/selectSubgruposContrato";
	import cabecalhoContrato from "../contratos/cabecarioContrato";
	export default {
		filters: {

		},
		data: () => ({
			dados: {
				contrato_subgrupo_id: '',
				sexo: 0,
				idade_maxima: '',
				idade_minima: '',
				tipo_consumo: 0,
				quantidade_atendimento: '',
				quantidade_local: '',
				hora_inicial: '',
				hora_final: '',
			},
			dias: [],
			selectDias: [{
					label: 'Domingo',
					value: '0'
				},
				{
					label: 'Segunda-feira',
					value: '1'
				},
				{
					label: 'Terça-feira',
					value: '2'
				},
				{
					label: 'Quarta-feira',
					value: '3'
				},
				{
					label: 'Quinta-feira',
					value: '4'
				},
				{
					label: 'Sexta-feira',
					value: '5'
				},
				{
					label: 'Sábado',
					value: '6'
				},
			]
		}),
		mounted() {},
		methods: {
			trocaTipoConsumo() {
				if (this.dados.tipo_consumo == '1') {
					this.dados.quantidade_atendimento = 0
					this.dados.quantidade_local = 0
				}
			},
			setSubgrupoSelecionado(subgrupoSelecionado) {
				this.dados.contrato_subgrupo_id = subgrupoSelecionado.id;
			},
			salvar() {
				axios
					.post(
						`${this.$store.state.serverURI}/api/administracao/agendas/createSubgrupoAtendimento`, {
							dados: this.dados,
							dias: this.dias
						},
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						console.log(response.data);
						this.$swal({
							type: "success",
							title: "Atendimento criado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						this.$router.go(-1);
					})
					.catch(error => {
						var erros = error.response.data.message + " ";
						for (var erro of Object.values(error.response.data.errors)) {
							erros += erro + " \n";
						}
						this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
			},
		},
		watch: {},
		components: {
			selectSubgrupo,
			cabecalhoContrato
		}
	}
</script>

<style>
	.v-select .dropdown-toggle {
		padding: 0 !important;
		border-radius: 0px !important;
	}

	.v-select input[type=search] {
		margin: 0 0 0 !important;
	}

	.v-select .selected-tag {
		margin: 5px !important;
	}
</style>



// WEBPACK FOOTER //
// novaAgendaSubgrupos.vue?0f02265b